var $c950e4b1c482abde$exports = {};
$c950e4b1c482abde$exports = {
  "alpha": "Alfa",
  "black": "juoda",
  "blue": "M\u0117lyna",
  "blue purple": "melsvai violetin\u0117",
  "brightness": "Ry\u0161kumas",
  "brown": "ruda",
  "brown yellow": "rusvai geltona",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u017Ealsvai m\u0117lyna",
  "cyan blue": "\u017Ealsvai m\u0117lyna",
  "dark": "tamsi",
  "gray": "pilka",
  "grayish": "pilk\u0161va",
  "green": "\u017Dalia",
  "green cyan": "\u017Ealsvai m\u0117lyna",
  "hue": "Atspalvis",
  "light": "\u0161viesi",
  "lightness": "\u0160viesumas",
  "magenta": "rausvai raudona",
  "magenta pink": "purpurin\u0117",
  "orange": "oran\u017Ein\u0117",
  "orange yellow": "oran\u017Einio atspalvio geltona",
  "pale": "bly\u0161ki",
  "pink": "ro\u017Ein\u0117",
  "pink red": "ro\u017Ein\u0117 raudona",
  "purple": "violetin\u0117",
  "purple magenta": "purpurin\u0117 rausvai raudona",
  "red": "Raudona",
  "red orange": "rausvai oran\u017Ein\u0117",
  "saturation": "\u012Esotinimas",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " skaidri");
  },
  "very dark": "labai tamsi",
  "very light": "labai \u0161viesi",
  "vibrant": "ry\u0161ki",
  "white": "balta",
  "yellow": "geltona",
  "yellow green": "gelsvai \u017Ealia"
};
export { $c950e4b1c482abde$exports as default };